import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Pencil, Paintbrush, Shield, ArrowRight } from 'lucide-react';

const icons = [Pencil, Paintbrush, Shield];

const ProcessSection = () => {
  const { t } = useLanguage();

  return (
    <section id="process" className="py-20 md:py-32 px-4 bg-secondary/30">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-5xl md:text-7xl tracking-wider text-center text-foreground mb-20"
          style={{ fontFamily: 'Bebas Neue' }}
        >
          {t.process.title}
        </motion.h2>

        <div className="flex flex-col md:flex-row items-stretch gap-6 md:gap-0">
          {t.process.steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="flex items-center flex-1 md:flex-row flex-col">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.2 }}
                  className="gradient-border-hover flex-1 p-6 rounded-sm border border-border/50 bg-card/30 backdrop-blur-sm hover:border-primary/40 hover:shadow-[0_0_25px_hsl(var(--primary)/0.12)] transition-all duration-500 text-center"
                >
                  <motion.div
                    whileInView={{ rotate: [0, -10, 10, 0], scale: [1, 1.15, 1] }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4 + i * 0.2, duration: 0.6 }}
                    className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center"
                  >
                    <Icon className="text-primary" size={24} />
                  </motion.div>
                  <h3
                    className="text-3xl tracking-wider text-foreground mb-2"
                    style={{ fontFamily: 'Bebas Neue' }}
                  >
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">{step.desc}</p>
                </motion.div>

                {i < t.process.steps.length - 1 && (
                  <motion.div
                    animate={{ x: [0, 6, 0] }}
                    transition={{ repeat: Infinity, duration: 1.5, delay: i * 0.3 }}
                    className="hidden md:block mx-4 shrink-0"
                  >
                    <ArrowRight className="text-primary/40" size={28} />
                  </motion.div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
